// keycloak.js
import Keycloak from 'keycloak-js';
import { EncryptStorage } from 'encrypt-storage';

const encryptStorage = new EncryptStorage('secret-key-value', { prefix: '@mwan' });
const KC_OFFLINE_TOKEN_KEY = 'kc_offline_token';

let keycloakInstance = null;
let keycloakInitOptions = null;

/**
 * Gets or creates the Keycloak singleton instance
 * @param {Object} config - Keycloak configuration
 * @returns {Object} - { keycloak: Keycloak instance, initOptions: initialization options }
 */
export const getKeycloakInstance = (config) => {
  if (!keycloakInstance) {
    console.log('🔑 Creating Keycloak singleton instance');
    console.log('🔧 Config:', config);

    keycloakInstance = new Keycloak({
      url: config.url,
      realm: config.realm,
      clientId: config.clientId,
    });

    const storedOfflineToken = encryptStorage.getItem(KC_OFFLINE_TOKEN_KEY);

    keycloakInitOptions = {
      onLoad: 'check-sso',
      checkLoginIframe: true,
      pkceMethod: 'S256',
      scope: 'openid offline_access',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
      messageReceiveTimeout: 30000,
      // Restore the offline token so keycloak-js can exchange it for a fresh
      // access token without requiring a live SSO session (handles cold-start offline → reconnect)
      ...(storedOfflineToken && { refreshToken: storedOfflineToken }),
    };

    console.log('✅ Keycloak instance created');
  } else {
    console.log('♻️ Reusing existing Keycloak instance');
  }

  return { keycloak: keycloakInstance, initOptions: keycloakInitOptions };
};

/**
 * Gets the Keycloak instance directly (for use in API calls)
 * Throws error if Keycloak hasn't been initialized yet
 * @returns {Keycloak} - The Keycloak instance
 */
export const getKeycloak = () => {
  if (!keycloakInstance) {
    throw new Error('Keycloak not initialized yet. Make sure KeycloakWrapper has been rendered.');
  }
  return keycloakInstance;
};

/**
 * Resets the Keycloak singleton (useful for testing or logout)
 */
export const resetKeycloakInstance = () => {
  console.log('🔄 Resetting Keycloak instance');
  keycloakInstance = null;
  keycloakInitOptions = null;
};